export const hexToRgb = (hex: string) => {
  const result = /^#?([\da-f]{2})([\da-f]{2})([\da-f]{2})$/i.exec(hex)
  if (!result) {
    return undefined
  }

  const [_, r, g, b] = result
  return `${parseInt(r!, 16)}, ${parseInt(g!, 16)}, ${parseInt(b!, 16)}`
}

export const hexToRgbA = (hex: string, alpha: number) => {
  const result = /^#?([\da-f]{2})([\da-f]{2})([\da-f]{2})$/i.exec(hex)
  if (!result) {
    return `rgba(0, 0, 0, ${alpha})`
  }

  const [_, r, g, b] = result
  return `rgba(${parseInt(r!, 16)}, ${parseInt(g!, 16)}, ${parseInt(b!, 16)}, ${alpha})`
}

export const addTransparency = (color: string, alpha: number) => {
  return `color-mix(in srgb, ${color}, transparent ${alpha * 100}%)`
}
